import { register } from 'swiper/element/bundle'
register()

class OfficeAvailabilityCarousel extends HTMLElement {
  constructor() {
    super()
    // Add a class to hide the carousel during initialization
    this.classList.add('carousel-initializing')
  }

  connectedCallback() {
    const swiperEl = this.querySelector('swiper-container')
    const cardsSpacing = Number(this.dataset.cardsSpacing || 16)
    const pagination = this.dataset.pagination
    const paginationEl = this.querySelector('.swiper-pagination')

    if (swiperEl) {
      // Check if Swiper is ready on the element
      if (typeof swiperEl.initialize !== 'function') {
        this.classList.remove('carousel-initializing')
        this.classList.add('initialization-failed')
        return
      }

      const slides = swiperEl.querySelectorAll('swiper-slide')
      slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index)
      })

      const swiperParams = {
        loop: true,
        spaceBetween: cardsSpacing,
        grabCursor: true,
        allowTouchMove: true,
        slidesPerView: 'auto',
      }

      if (pagination === 'true' && paginationEl) {
        swiperParams.pagination = {
          el: paginationEl,
          clickable: true,
        }
      }

      // Assign parameters and initialize Swiper
      Object.assign(swiperEl, swiperParams)
      swiperEl.initialize()

      // Post-initialization adjustments
      if (swiperEl.swiper) {
        swiperEl.swiper.el.style.overflow = 'visible'
      }

      // Remove initialization class once everything is set up
      requestAnimationFrame(() => {
        this.classList.remove('carousel-initializing')
        this.classList.add('initialized')
      })
    }
  }
}

if (!customElements.get('office-availability-carousel')) {
  customElements.define('office-availability-carousel', OfficeAvailabilityCarousel)
}
